/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import { use } from 'fierry/react';

import Galaxy from 'solis/application/galaxy';

import Text from 'solis/react/primitive/text';

import UserName from 'solis/claude/element/user/name';
import SectorPayout from 'solis/claude/element/sector.payout';


export default ({ sector }) =>
{
  const galaxy = use(Galaxy);

  return (
    <Card>
      <Flex direction = 'column' gap = '1'>

        <Flex justify = 'between' align = 'center' gap = '2'>
          <Text.Label>{'Sector ' + sector.cass.name}</Text.Label>
          <UserName galaxy = {galaxy} user = {sector.cass.user} />
        </Flex>

        <Flex justify = 'between' align = 'center' gap = '2'>
          <Text.Note>{'Currency: ' + sector.cass.currency}</Text.Note>
          <SectorPayout sector = {sector} />
        </Flex>

      </Flex>
    </Card>
  );
};
